import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import moment from 'moment'

// MUI
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

// MUI Icons
import CheckIcon from '@mui/icons-material/Check';

// Utils
import { plateSplitter, numberWithSeperators } from "../util/helper";



// Text width 
const titleWidth = '180px';

function SummaryContent(props) {

    // Props
    const { t } = useTranslation()
    const portLogin = useSelector(state => state.portLogin)
    const form = useSelector(state => state.form)
    const vehicle = useSelector(state => state.vehicle)

    const theme = useTheme();
    // Styles
    const styles = {
        greenCheckIcon: {
            fill: theme.palette.primary.main,
        },
        accordionRoot: {
            width: '100%'
        },
    }

    // Media query screen size
    const xsDown = useMediaQuery(theme.breakpoints.down('sm'));
    const smDown = useMediaQuery(theme.breakpoints.down('md'));
    const mdDown = useMediaQuery(theme.breakpoints.down('lg'));
    const lgDown = useMediaQuery(theme.breakpoints.down('xl'));
    const xlDown = useMediaQuery(theme.breakpoints.down('xl'));

    // Calculate spacing 
    const spacingSummary = useMemo(() => {

        // Spacing
        const spacings = { xs: 0, sm: 1, md: 1, lg: 1, xl: 2 }

        if (xsDown) {
            return spacings.xs
        }
        else {
            if (smDown) {
                return spacings.sm
            }
            else {
                if (mdDown) {
                    return spacings.md
                }
                else {
                    if (lgDown) {
                        return spacings.lg
                    }
                    else {
                        if (xlDown) {
                            return spacings.xl
                        }
                        else {
                            return spacings.xl
                        }
                    }
                }
            }
        }

    }, [xsDown, smDown, mdDown, lgDown, xlDown]);


    return (
        <Grid container spacing={spacingSummary}>

            {
                portLogin && vehicle &&
                <Grid item xs={12} container wrap='nowrap'>
                    <Box minWidth={titleWidth}>
                        <Typography variant='body1' color='textPrimary'>{t('plate') + ':'}</Typography>
                    </Box>
                    <Typography variant='body1' color='textSecondary' style={{ wordBreak: 'break-word' }}>{plateSplitter(vehicle.plate)}</Typography>
                </Grid>
            }
            {
                !portLogin && form.vehicleInfo &&
                <Grid item xs={12} container wrap='nowrap' >
                    <Box minWidth={titleWidth}>
                        <Typography variant='body1' color='textPrimary'>{t('plateChassisInput') + ':'}</Typography>

                    </Box>
                    <Typography variant='body1' color='textSecondary' style={{ wordBreak: 'break-word' }}>{form.vehicleInfo}</Typography>
                </Grid>
            }
            {
                form.km &&
                <Grid item xs={12} container wrap='nowrap'>
                    <Typography variant='body1' color='textPrimary'>
                        <Box component="span" display="inline-flex" minWidth={titleWidth}>{t('km') + ':'}</Box>
                        <Typography variant='body1' component='span' color='textSecondary'>{numberWithSeperators(form.km)} km</Typography>
                    </Typography>
                </Grid>
            }
            {
                form.vale &&
                <Grid item xs={12} container wrap='nowrap'>
                    <Box minWidth={titleWidth}>
                        <Typography variant='body1' color='textPrimary'>{t('valeSummry') + ':'}</Typography>
                    </Box>
                    <Box display="flex">
                        {form.vale && <CheckIcon sx={styles.greenCheckIcon} />}
                    </Box>
                </Grid>
            }
            {
                form.dealer &&
                <Grid item xs={12} container wrap='nowrap'>
                    <Box minWidth={titleWidth}>
                        <Typography variant='body1' color='textPrimary'>{t('dealerName') + ':'}</Typography>
                    </Box>
                    <Typography variant='body1' color='textSecondary' style={{ wordBreak: 'break-word' }}>{form.dealer.name}</Typography>
                </Grid>
            }
            {
                form.slot &&
                <Grid item xs={12} container wrap='nowrap'>
                    <Box minWidth={titleWidth}>
                        <Typography variant='body1' color='textPrimary'>{t('timeSlot') + ':'}</Typography>
                    </Box>
                    <Typography variant='body1' color='textSecondary'>{moment(form.timeSlot.date + ' ' + form.slot).format('Do MMMM YYYY, HH:mm')}</Typography>
                </Grid>
            }
            {
                form.phone &&
                <Grid item xs={12} container wrap='nowrap'>
                    <Box minWidth={titleWidth}>
                        <Typography variant='body1' color='textPrimary'>{t('phone') + ':'}</Typography>
                    </Box>
                    <Typography variant='body1' color='textSecondary'>{portLogin ? `(${form.phone.substring(0, 2)}) ${form.phone.substring(2, 5)} ${form.phone.substring(5, 8)} ${form.phone.substring(8, 10)} ${form.phone.substring(10, 12)}` : form.phone}</Typography>
                </Grid>
            }
            {
                form.name &&
                <Grid item xs={12} container wrap='nowrap'>
                    <Box minWidth={titleWidth}>
                        <Typography variant='body1' color='textPrimary'>{t('name') + ':'}</Typography>
                    </Box>
                    <Typography variant='body1' color='textSecondary' style={{ wordBreak: 'break-word' }}>{form.name}</Typography>
                </Grid>
            }
            {
                form.surname &&
                <Grid item xs={12} container wrap='nowrap'>
                    <Box minWidth={titleWidth}>
                        <Typography variant='body1' color='textPrimary'>{t('surname') + ':'}</Typography>
                    </Box>
                    <Typography variant='body1' color='textSecondary' style={{ wordBreak: 'break-word' }}>{form.surname}</Typography>
                </Grid>
            }
            {
                form.email &&
                <Grid item xs={12} container wrap='nowrap'>
                    <Box minWidth={titleWidth}>
                        <Typography variant='body1' color='textPrimary'>{t('email') + ':'}</Typography>
                    </Box>
                    <Box>
                        <Typography style={{ wordBreak: 'break-word' }}
                            variant='body1' color='textSecondary'>
                            {form.email}
                        </Typography>
                    </Box>
                </Grid>
            }
            {
                !portLogin && form.permission &&
                <Grid item xs={12} container wrap='nowrap'>
                    <Box minWidth={titleWidth}>
                        <Typography variant='body1' color='textPrimary'>{t('contactPermission') + ':'}</Typography>
                    </Box>
                    <Box>
                        <Typography variant='body1' color='textSecondary'>
                            {
                                function getPermisssionStrings() {
                                    const permissions = []
                                    if (form.phonePermission) permissions.push(t('phonePermission'))
                                    if (form.smsPermission) permissions.push(t('smsPermission'))
                                    if (form.emailPermission) permissions.push(t('emailPermission'))
                                    return permissions.join(', ')
                                }()

                            }
                        </Typography>
                    </Box>
                </Grid>
            }

            {
                form.appointmentRequests.length > 0 &&
                <Grid item xs={12} container wrap='nowrap'>
                    <Box minWidth={titleWidth}>
                        <Typography variant='body1' color='textPrimary'>{t('appointmentRequestsTitle') + ':'}</Typography>
                    </Box>
                    <Box>
                        <Typography variant='body1' color='textSecondary'>
                            {
                                form.appointmentRequests.map(a => a.note).join(', ')
                            }
                        </Typography>
                    </Box>
                </Grid>
            }
        </Grid>
    )
}

// Connect redux and translation
export default SummaryContent